export * from './invoice';
export * from './hooks';

export const isInputSanitized = (input: string): boolean => {
  const unsafe = ['&', '<', '>', '"', "'", '/', '`', '='];
  return !unsafe.some(char => input.includes(char));
};
